import names from '@/modules/core/routers/names'
import Base from "@/modules/core/Base.vue"
import Registration from "@/modules/core/pages/registration/Registration.vue"
import RegistrationMainInfo from "@/modules/core/components/registration/RegistrationMainInfo.vue"
import RegistrationIndividualInfo from "@/modules/core/components/registration/RegistrationIndividualInfo.vue"
import RegistrationApprove from "@/modules/core/components/registration/RegistrationApprove.vue"
import Recovery from "@/modules/core/pages/recovery/Recovery.vue"
import { MENDELEEV_INSTANCE } from "@/helper/consts"
import CreateUser from "@/modules/core/pages/registration/CreateUser.vue"
import RegistrationInfoSentEmail from "@/modules/core/components/registration/RegistrationInfoSentEmail.vue"
import RegistrationInfoApproveEmail from "@/modules/core/components/registration/RegistrationInfoApproveEmail.vue"
import ChangeForgetPassword from "@/modules/core/components/recovery/ChangeForgetPassword.vue"
import AuthFromAnother from "@/modules/core/pages/science_id/AuthFromAnother.vue"
import OauthScienceId from "@/modules/core/pages/science_id/OauthScienceId.vue"
import BindAccounts from "@/modules/core/pages/science_id/BindAccounts.vue"
import RegistrationInfoReSendEmail from "@/modules/core/components/registration/RegistrationInfoReSendEmail.vue"
import Update from "@/modules/core/pages/update/Update.vue"
import UpdateMainInfo from "@/modules/core/components/update/UpdateMainInfo.vue"
import UpdateIndividualInfo from "@/modules/core/components/update/UpdateIndividualInfo.vue"

export default ([
  // {
  //   path: '/no_access',
  //   name: names.NO_ACCESS_PAGE.BASE,
  //   component: noAccessPage,
  //   meta: {
  //     requiredAuth: true,
  //     instances: [
  //       MENDELEEV_INSTANCE
  //     ]
  //   },
  //   children: []
  // },
  {
    path: '',
    name: names.MAIN,
    component: Base,
    meta: {
      breadcrumb: 'Вход в ЛК',
      requiredAuth: false,
      instances: [
        MENDELEEV_INSTANCE
      ]
    },
    children: [
      {
        path: 'recovery',
        name: names.RECOVERY.PAGE,
        component: Recovery,
        meta: {
          breadcrumb: 'Восстановление пароля',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'email/approve',
        name: names.EMAIL_APPROVE.PAGE,
        component: RegistrationInfoApproveEmail,
        meta: {
          breadcrumb: 'Подтверждение почты',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'email/resend',
        name: names.EMAIL_RESEND.PAGE,
        component: RegistrationInfoReSendEmail,
        meta: {
          breadcrumb: 'Повторная отправка письма на почту',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'password/approve',
        name: names.RECOVERY.APPROVE,
        component: ChangeForgetPassword,
        meta: {
          breadcrumb: 'Смена пароля',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'registration',
        name: names.CREATE_USER.PAGE,
        component: CreateUser,
        meta: {
          breadcrumb: 'Создание пользователя',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: 'info',
            name: names.CREATE_USER.INFO,
            component: RegistrationInfoSentEmail,
            meta: {
              breadcrumb: 'Информация с инструкцией',
              requiredAuth: false,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
        ]
      },
      {
        path: 'scienceid/register',
        name: names.SCIENCE_ID.PAGE,
        component: AuthFromAnother,
        meta: {
          breadcrumb: 'Регистрация через ScienceId',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'scienceid/oauth/callback',
        name: names.SCIENCE_ID.OAUTH,
        component: OauthScienceId,
        meta: {
          breadcrumb: 'Вход через ScienceId',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'scienceid/bind',
        name: names.SCIENCE_ID.BIND,
        component: BindAccounts,
        meta: {
          breadcrumb: 'Связать аккаунты',
          requiredAuth: false,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'registration/member',
        name: names.REGISTRATION.PAGE,
        component: Registration,
        meta: {
          breadcrumb: 'Регистрация в ЛК',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: 'main',
            name: names.REGISTRATION_MAIN.PAGE,
            component: RegistrationMainInfo,
            meta: {
              breadcrumb: 'Заполнение основной информации',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
          {
            path: 'individual',
            name: names.REGISTRATION_INDIVIDUAL.PAGE,
            component: RegistrationIndividualInfo,
            meta: {
              breadcrumb: 'Заполнение индивидуальной информации',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
          {
            path: 'approve',
            name: names.REGISTRATION_APPROVE.PAGE,
            component: RegistrationApprove,
            meta: {
              breadcrumb: 'Выражение согласий',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          }
        ]
      },
      {
        path: 'update/member',
        name: names.UPDATE.PAGE,
        component: Update,
        meta: {
          breadcrumb: 'Актуализация информации в ЛК',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: 'main',
            name: names.UPDATE_MAIN.PAGE,
            component: UpdateMainInfo,
            meta: {
              breadcrumb: 'Актуализация основной информации',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
          {
            path: 'individual',
            name: names.UPDATE_INDIVIDUAL.PAGE,
            component: UpdateIndividualInfo,
            meta: {
              breadcrumb: 'Актуализация индивидуальной информации',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
          // {
          //   path: 'approve',
          //   name: names.UPDATE_APPROVE.PAGE,
          //   component: RegistrationApprove,
          //   meta: {
          //     breadcrumb: 'Выражение согласий',
          //     requiredAuth: true,
          //     instances: [
          //       MENDELEEV_INSTANCE
          //     ]
          //   },
          //   children: []
          // }
        ]
      }
    ]
  }
])
